<template>
  <!--Modal Nuevo Solicitud-->
  <transition name="fade">
    <div class="modal-overlay">
      <div class="modal-dialog modal-xl" role="solicitud">
        <div class="modal-content">
          <div class="header">
            <img :src="img" alt="">
            <button type="button" class="closeModel" data-dismiss="modal" aria-label="Cerrar"
              @click="cancelarSolicitud()">
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                <circle cx="15" cy="15" r="15" fill="#006C90" />
                <path
                  d="M21 8.97714L19.7914 7.5L15 13.3562L10.2086 7.5L9 8.97714L13.7914 14.8333L9 20.6895L10.2086 22.1667L15 16.3105L19.7914 22.1667L21 20.6895L16.2086 14.8333L21 8.97714Z"
                  fill="white" />
              </svg>
            </button>
          </div>
          <div class="modal-body row container col-12 info">
            <div class="col col-12 container">
              <label class="title-body">{{ titulo }}</label><br />
              <p class="parrafo col-12 container"> {{ noticia }} </p>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-cancelar" @click="cancelarSolicitud()">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>

  <Loading v-if="loading"></Loading>
</template>
    
<script>
import { Actions } from "@/store/enums/StoreEnums";
import { ref } from "vue";
import { useStore } from "vuex";
import Loading from "@/components/Loading.vue";

export default {
  name: "Licitar",
  emits: ["cancelar", "guardarLicitante"],
  components: {
    Loading,
  },
  data() {
    return {
      carga: false,
      nombreProveedor: "",
      rut: "",
      telefono: "",
      correo: "",
      archivo: File,
    };
  },
  setup(props, { emit }) {
    var loading = ref(false);
    const titulo = document.getElementById("titulo").textContent;
    const noticia = document.getElementById("noticia").textContent;
    const img = document.getElementById("img").textContent;


    const cancelarSolicitud = () => {
      emit("cancelar", null);
    };

    return {
      cancelarSolicitud,
      loading,
      titulo,
      noticia,
      img,
    };
  },
};
</script>
    
<style scoped>

.parrafo {
  text-align: justify;
}
.mensajeError {
  color: red;
  font-size: 0.6rem;
}

.correosList {
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
  flex-wrap: wrap;
}

.correosSeleccionados {
  color: var(--white, #fff);
  text-align: center;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 475;
  line-height: normal;
  border-radius: 10px;
  background: rgba(0, 108, 144, 0.4);
  padding: 0px 5px;
  cursor: pointer;
  margin: 5px;
}

.options {
  color: #99abb4;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.mensaje {
  color: #99abb4;
  font-size: 0.7rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-dialog {


}

.header {
  height: 18rem;
  position: relative;
  left: 0 !important;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}

.header img {
  object-fit: cover;
  height: 100%;
  width: 100%;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}

.modal-title {
  color: #006c90;
  font-size: 1.18rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.closeModel {
  border: 0px;
  background-color: rgb(0,0,0,0);
  position: absolute;
  top: 10px;
  right: 10px;
}

.title-body {
  color: #006C90;
  font-size: 2rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  align-items: center;
  display: flex;
  justify-content: center;
}

.inputName {
  border-radius: 50px;
  border: 1px solid #cecece;
  background: #fff;
  width: 100%;
  height: 35px;
  text-align: center;
}

.btn-guardar {
  display: flex;
  width: 140px;
  height: 27px;
  padding: 5px 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 10px;
  border: 1px solid #006c90;
  background: #006c90;
  color: #fff;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  width: 45%;
}

.btn-cancelar {
  display: flex;
  width: 140px;
  height: 27px;
  padding: 5px 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 10px;
  border: 1px solid #99c4d3;
  background: #99c4d3;
  color: #fff;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  width: 45%;
}

.modal-footer {
  padding: 0px 0px 1.5rem 0px !important;
  border: 0px !important;
  display: flex;
  justify-content: center;
}

.modal-overlay {
  position: fixed;
}

.info label {
  margin-top: 1.5rem
}

.modal-footer {
  margin-top: 2rem !important;
}
</style>
    